import styled, { css } from 'styled-components';
import { maxWidth, minWidth } from '@/assets/styles/mixins.css';
import vars from '@/assets/styles/vars';

const Breadcrumbs = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 10px;
  row-gap: 5px;
  align-items: center;
  position: relative;

  ${(props) =>
    props.theme === 'light' &&
    css`
      ${Breadcrumbs.Item}:last-child ${Breadcrumbs.Link} {
        color: var(--color-decor, #b69b64);
      }
    `}
`;

Breadcrumbs.Item = styled.div`
  font-size: 13px;
  line-height: 16px;
  text-transform: uppercase;
  display: flex;
  gap: 10px;
  align-items: center;
  width: fit-content;

  &::after {
    content: '';
    display: block;
    width: 6px;
    height: 10px;
    background-image: url("data:image/svg+xml,%3Csvg width='6' height='10' viewBox='0 0 6 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M4.52539 5.70686L4.52563 5.70711L5.23274 5L4.87919 4.64645L1.06115 0.828407L0.707595 0.474854L0.000488035 1.18196L0.354041 1.53551L3.81828 4.99976L0.353553 8.46449L0 8.81804L0.707107 9.52515L1.06066 9.17159L4.52539 5.70686Z' fill='%23C5C5C5'/%3E%3C/svg%3E ");
    background-repeat: no-repeat;
    background-position: center;
  }

  &:last-child::after {
    content: none;
  }
`;

Breadcrumbs.Link = styled.a`
  color: #a8a8a8;
  pointer-events: all;
  ${Breadcrumbs.Item}:last-child & {
    color: #fff;
  }
`;

export default Breadcrumbs;
